import { render, staticRenderFns } from "./CustomerEventCard.vue?vue&type=template&id=ed6f5d10&"
import script from "./CustomerEventCard.vue?vue&type=script&lang=ts&"
export * from "./CustomerEventCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports